<div class="kt-portlet">
    <div class="kt-portlet__body justifyPadding">
        <div class="content">
            <div class="titulo-content center">
                <h3 class="titulo" *ngIf="!idModelo"><i class="fas fa-user"></i> Agregar Modelo </h3>
                <h3 class="titulo" *ngIf="idModelo"><i class="fas fa-user"></i> Editar Modelo</h3>
            </div>
            <mat-divider></mat-divider>
            <br>
            <form class="kt-form" [formGroup]="modeloForm" autocomplete="off" enctype="multipart/form-data">
                <div class="kt-portlet__body">
                    <div class="kt-form__section kt-form__section--first">
                        <div class="row">
                            <div class="col-md-6 col-lg-12">
                                <div class="form-group kt-form__group">
                                    <mat-form-field class="col col-md-4 col-lg-4">
                                        <mat-label id="matLabel">Nombre</mat-label>
                                        <input matInput placeholder="" required formControlName="Nombre">
                                    </mat-form-field>
                                    <mat-form-field class="col col-md-4 col-lg-4">
                                        <mat-label id="matLabel">Marca</mat-label>
                                        <mat-select formControlName="IdMarca">
                                            <mat-option *ngFor="let marca of marcasDispositivo" [value]="marca.id">
                                                {{marca.nombre}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="kt-portlet__foot">
                    <div class="kt-form__actions kt-form__actions">
                        <button mat-raised-button id="boton-sion" (click)="onSubmit()" [disabled]="modeloForm.invalid || loading" [ngClass]="{'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading}" style="margin-right: 15px;">
                            <i class="fal fa-save"></i>
                            Guardar
                        </button>
                        <button mat-raised-button (click)="onCancel()"><i class="fas fa-times"></i>&nbsp;Cancelar</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
